import { PlusOutlined } from '@ant-design/icons';
import { EllipsisSpan, Paging, Table, usePaging, Button } from '@maxtropy/components';
import { Space } from 'antd';
import { ColumnType } from 'antd/es/table';
import { forwardRef, Ref, useEffect, useImperativeHandle, useState } from 'react';
import { OuStaffType, OuStaffTypeDisplay } from '../../../../api/const';
import { getStaffOuOwnPage, OuResponse } from '../../../../api/staff';
import OuModal, { ouColumns } from './OuModal';
import { unionBy } from 'lodash-es';

interface OuListProps {
  staffId?: number;
  isEdit?: boolean;
}

// 定义暴露给父组件的类型
export interface ChildRef {
  getValue: () => OuResponse[];
}

export const columns: ColumnType<OuResponse>[] = [
  ...ouColumns,
  {
    title: '权限级别',
    dataIndex: 'memberType',
    width: 200,
    render: (v: OuStaffType) => <EllipsisSpan value={OuStaffTypeDisplay[v]} />,
  },
];

const OuList = forwardRef(({ staffId, isEdit }: OuListProps, ref: Ref<ChildRef>) => {
  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount } = pagingInfo;
  const [type, setType] = useState<OuStaffType>();
  const [visible, setVisible] = useState<boolean>();
  const [data, setData] = useState<OuResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (staffId) {
      setLoading(true);
      getStaffOuOwnPage({
        staffId: staffId,
        page: pageOffset,
        size: pageSize,
      })
        .then(res => {
          setData(res.list);
          setTotalCount(res.total);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffId, pageOffset, pageSize, setTotalCount]);

  useImperativeHandle(ref, () => ({
    getValue: () => data,
  }));

  const buildColumns = [
    ...columns,
    {
      title: '操作',
      hidden: !isEdit,
      width: 200,
      render: (record: OuResponse) => (
        <Space>
          <Button style={{ paddingLeft: 0, paddingRight: 0 }} type="link" onClick={() => onUnBindOu(record.id)}>
            移出
          </Button>
        </Space>
      ),
    },
  ];

  const onUnBindAllOu = () => {
    setData([]);
  };

  const onUnBindOu = (id: number) => {
    setData(data.filter(item => item.id !== id));
  };

  return (
    <>
      <Space
        size={8}
        style={{
          marginBottom: 10,
          marginTop: 8,
        }}
      >
        <Button
          icon={<PlusOutlined />}
          disabled={!isEdit}
          onClick={() => {
            setType(OuStaffType.ADMINISTRATOR);
            setVisible(true);
          }}
        >
          添加为管理员
        </Button>
        <Button
          icon={<PlusOutlined />}
          disabled={!isEdit}
          onClick={() => {
            setType(OuStaffType.MEMBER);
            setVisible(true);
          }}
        >
          添加为成员
        </Button>
        <Button disabled={!isEdit} onClick={onUnBindAllOu}>
          移出所有运营单元
        </Button>
      </Space>
      <Table loading={loading} rowKey="id" columns={buildColumns} dataSource={data} scroll={{ y: 300 }} />
      {!isEdit && <Paging pagingInfo={pagingInfo} />}
      {visible && (
        <OuModal
          staffId={staffId}
          type={type}
          onCancel={() => {
            setType(undefined);
            setVisible(false);
          }}
          selectedOuData={(selectedOus: OuResponse[]) => {
            setData(unionBy([...selectedOus, ...(data ?? [])], 'id'));
          }}
        />
      )}
    </>
  );
});

export default OuList;
